<template>
	<el-dialog
		append-to-body
		destroy-on-close
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">CẬP NHẬT THÔNG TIN</h4>
				<p class="text-base font-medium">Khu/Ao: {{data.zone ? `${data.zone} - ` : ''}}{{ data.name }}</p>
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div style="background-color: #F2F2F2;">
				<div class="p-6">
					<label class="text-base vs-input--label">Thông tin</label>
				</div>
			</div>
			
			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">Lượng thức ăn: </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.feedQty" class="w-full" name="feedQty" :data-vv-as="'feedQty'" :placeholder="'Nhập lượng thức ăn'" />
						<!-- <span class="text-danger text-sm break-normal" v-show="errors.has('street')">{{ errors.first("street") }}</span> -->
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">Loại thức ăn: </label>
						<cbs-input v-model="currentData.feedCode" class="w-full" name="feedCode" :data-vv-as="'feedCode'" :placeholder="'Nhập loại thức ăn'" />
						<!-- <span class="text-danger text-sm break-normal" v-show="errors.has('street')">{{ errors.first("street") }}</span> -->
					</div>
				</div>

				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">Hao hụt con: </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.lossQty" class="w-full" name="lossQty" :data-vv-as="'lossQty'" :placeholder="'Nhập số lượng hao hụt'" />
						<!-- <span class="text-danger text-sm break-normal" v-show="errors.has('street')">{{ errors.first("street") }}</span> -->
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">Hao hụt kg: </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.lossKg" class="w-full" name="lossKg" :data-vv-as="'lossKg'" :placeholder="'Nhập khối lượng hao hụt'" />
						<!-- <span class="text-danger text-sm break-normal" v-show="errors.has('street')">{{ errors.first("street") }}</span> -->
					</div>
				</div>

				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">pH: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.ph" class="w-full" name="ph" :data-vv-as="'ph'" :placeholder="'Chỉ số pH'" />
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">NO2: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.no2" class="w-full" name="no2" :data-vv-as="'no2'" :placeholder="'Chỉ số NO2'" />
					</div>
				</div>

				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">TAN: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.tan" class="w-full" name="tan" :data-vv-as="'tan'" :placeholder="'Chỉ số TAN'" />
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">DO: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.do" class="w-full" name="_do" :data-vv-as="'_do'" :placeholder="'Chỉ số Oxy hòa tan'" />
					</div>
				</div>

				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">KH: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.kh" class="w-full" name="kh" :data-vv-as="'kh'" :placeholder="'Chỉ số kềm'" />
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">Nhiệt độ: </label>
						<cbs-input v-mask="imNumericOptions" v-model="currentData.t" class="w-full" name="_t" :data-vv-as="'_t'" :placeholder="'Nhiệt độ nước'" />
					</div>
				</div>

				<div class="grid">
					<div class="mb-5">
						<label class="text-base vs-input--label">Thuốc, hóa chất </label>
						<cbs-input v-model="currentData.noteTreatment" class="w-full" name="noteTreatment" :data-vv-as="'noteTreatment'" :placeholder="''" />
					</div>
				</div>

				<div class="grid">
					<div class="mb-5">
						<label class="text-base vs-input--label">Ghi chú khác </label>
						<cbs-input v-model="currentData.noteOther" class="w-full" name="noteOther" :data-vv-as="'noteOther'" :placeholder="''" />
					</div>
				</div>
				
			</div>

			<div class="grid grid-cols-2" style="background-color: #F2F2F2;">
				<div class="p-6">
					<div class="pr-4">
						<label class="text-base vs-input--label">Lũy tiến</label>
					</div>
				</div>
				<div style="padding-top: 12px; padding-right: 1.5rem;">
					<cbs-date-picker
						clearable
						class="w-full"
						prefix-icon="''"
						ref="dateTimePickerRef"
						:format="'DD/MM/YYYY'"
						value-format="yyyy-MM-dd"
						:placeholder="'Chọn ngày'"
						v-model="lastUpdatedOverview"
					/>
				</div>
			</div>

			<div class="p-6" v-if="isPopupActiveLocal">
				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">Tổng lượng thức ăn (kg): </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.feedingTtl" class="w-full" name="feedingTtl" :data-vv-as="'feedingTtl'" :placeholder="'Nhập tổng lượng thức ăn'" />
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">Tổng hao hụt con: </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.lossQtyTtl" class="w-full" name="lossQtyTtl" :data-vv-as="'lossQtyTtl'" :placeholder="'Nhập số lượng cá hao'" />
					</div>
				</div>

				<div class="grid grid-cols-2">
					<div class="mb-5  pr-4">
						<label class="text-base vs-input--label">Tổng hao hụt kg: </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.lossKgTtl" class="w-full" name="lossKgTtl" :data-vv-as="'lossKgTtl'" :placeholder="'Nhập khối lượng cá hao'" />
					</div>
					<div class="mb-5">
						<label class="text-base vs-input--label">Trọng lượng bình quân (gr): </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.fishGrowWeight" class="w-full" name="fishGrowWeight" :data-vv-as="'fishGrowWeight'" :placeholder="'Nhập trọng lượng cá'" />
					</div>
				</div>

				<div class="grid">
					<div class="mb-5">
						<label class="text-base vs-input--label">Sản lượng cá ước lượng (kg) </label>
						<cbs-input v-mask="imCurrencyOptions" v-model="currentData.estFishQty" class="w-full" name="estFishQty" :data-vv-as="'estFishQty'" :placeholder="'Nhập khối lượng cá ước lượng'" />
					</div>
				</div>
				
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData">{{ $t("Save") }}</vs-button>
		</div>
	</el-dialog>
</template>
<script>
import * as _ from "lodash";
const moment = require('moment');
const dateNow = moment().format('YYYY-MM-DD');
const imOptions = {alias: 'currency', digitsOptional: true, autoUnmask: true};

const emptyCurrentData = {
  feedCode: '',
  feedQty: '',
  lossQty: '',
  lossKg: '',
  lossQtyPm: '',
  lossKgPm: '',
  ph: '',
  no2: '',
  tan: '',
  do: '',
  kh: '',
  t: '',
  noteTreatment: '',
  noteOther: '',
  feedingTtl: '',
  lossQtyTtl: '',
  lossKgTtl: '',
  estFishQty: '',
  fishGrowWeight: '',
  stockingDate: '',
};

export default {
	name: "PondUpdate",
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			imCurrencyOptions: imOptions,
			imNumericOptions: {alias: 'decimal', digitsOptional: true},
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			currentData: _.cloneDeep(emptyCurrentData),
			lastUpdatedOverview: null
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { _id, fullname, email } = this.data;
			if (!this.data._id) {
				this.initValues();
			} else {
				this.id = _id;
				this.fullname = fullname;
				this.email = email;
			}

			this.isFormDirty = false;
			this.initFormData = {
				id: this.id,
				fullname: this.fullname,
				email: this.email
			};
		},

		computedFormData: {
			handler: function(newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		computedFormData() {
			return {
				id: this.id,
				fullname: this.fullname,
				email: this.email
			};
		}
	},

	created() {
		this.prepaire();
	},
	methods: {
		openDatePicker() {
			if (this.$refs.dateTimePickerRef && this.$refs.dateTimePickerRef.$el.querySelector('input')) {
				this.$refs.dateTimePickerRef.$el.querySelector('input').focus();
			}
		},
		prepaire() {
			let pond = this.data;
			this.lastUpdatedOverview = null;
			if (pond) {
				this.lastUpdatedOverview = pond.lastUpdatedOverview || null;
				let dateMaps = {};
				this.prepairData(pond, dateMaps, 'feeding');
				this.prepairData(pond, dateMaps, 'fishLoss');
				this.prepairData(pond, dateMaps, 'fishGrow');
				this.prepairData(pond, dateMaps, 'enviroment');
				this.prepairData(pond, dateMaps, 'notes');

				let currentData = _.cloneDeep(emptyCurrentData);
				if (dateMaps.hasOwnProperty(dateNow)) {
					const dateData = dateMaps[dateNow];
					currentData.feedCode = dateData.feeding
					? dateData.feeding.feedCode
					: '';
					currentData.fishGrowWeight =
					dateData.fishGrow && dateData.fishGrow.weight
						? dateData.fishGrow.weight.toString()
						: '';
					currentData.feedQty =
					dateData.feeding && dateData.feeding.quantity
						? dateData.feeding.quantity.toString()
						: '';
					currentData.lossQty =
					dateData.fishLoss && dateData.fishLoss.quantityPerIndividual
						? dateData.fishLoss.quantityPerIndividual.toString()
						: '';
					currentData.lossQtyPm =
					dateData.fishLoss && dateData.fishLoss.quantityPerIndividualPm
						? dateData.fishLoss.quantityPerIndividualPm.toString()
						: '';
					currentData.lossKg =
					dateData.fishLoss && dateData.fishLoss.quantityPerKg
						? dateData.fishLoss.quantityPerKg.toString()
						: '';
					currentData.lossKgPm =
					dateData.fishLoss && dateData.fishLoss.quantityPerKgPm
						? dateData.fishLoss.quantityPerKgPm.toString()
						: '';
					currentData.ph =
					dateData.enviroment && dateData.enviroment.ph
						? dateData.enviroment.ph.toString()
						: '';
					currentData.no2 =
					dateData.enviroment && dateData.enviroment.no2
						? dateData.enviroment.no2.toString()
						: '';
					currentData.tan =
					dateData.enviroment && dateData.enviroment.tan
						? dateData.enviroment.tan.toString()
						: '';
					currentData.do =
					dateData.enviroment && dateData.enviroment.do
						? dateData.enviroment.do.toString()
						: '';
					currentData.kh =
					dateData.enviroment && dateData.enviroment.kh
						? dateData.enviroment.kh.toString()
						: '';
					currentData.t =
					dateData.enviroment && dateData.enviroment.temperature
						? dateData.enviroment.temperature.toString()
						: '';
					currentData.noteTreatment =
					dateData.notes && dateData.notes.diseaseTreatment
						? dateData.notes.diseaseTreatment.toString()
						: '';
					currentData.noteOther =
					dateData.notes && dateData.notes.other
						? dateData.notes.other.toString()
						: '';
				}
				if (
					pond &&
					pond.stocking &&
					pond.stocking.data &&
					pond.stocking.data.hasOwnProperty('0')
				) {
					let stocking = pond.stocking.data[0];
					currentData.stockingDate = stocking ? stocking.datetime : '';
				}
				if (
					pond &&
					pond.feeding &&
					pond.feeding.overview
				) {
					currentData.feedingTtl = pond.feeding.overview.totalQty
					? pond.feeding.overview.totalQty.toString()
					: '0';
				}
				if (
					pond &&
					pond.fishLoss &&
					pond.fishLoss.overview
				) {
					currentData.lossQtyTtl = pond.fishLoss.overview
					.totalQtyPerIndividual
					? pond.fishLoss.overview.totalQtyPerIndividual.toString()
					: '0';
				}
				if (
					pond &&
					pond.fishLoss &&
					pond.fishLoss.overview
				) {
					currentData.lossKgTtl = pond.fishLoss.overview
					.totalQtyPerKg
					? pond.fishLoss.overview.totalQtyPerKg.toString()
					: '0';
				}
				if (
					pond &&
					pond.fishGrow &&
					pond.fishGrow.overview
				) {
					currentData.estFishQty = pond.fishGrow.overview.estYield
					? pond.fishGrow.overview.estYield.toString()
					: '0';
					currentData.fishGrowWeight = pond.fishGrow.overview.weight
					? pond.fishGrow.overview.weight.toString()
					: '';
				}

				this.currentData = currentData;
			}
		},

		prepairData(data, map, key) {
			const dataMap = {
				feeding: {
					quantity: '',
					feedCode: '',
				},
				fishLoss: {
					quantityPerIndividual: '',
					quantityPerKg: '',
				},
				enviroment: null,
				notes: null,
			};
			if (
				data &&
				data[key] &&
				typeof data[key] === 'object' &&
				Array.isArray(data[key].data)
			) {
				data[key].data.map(item => {
					if (!map.hasOwnProperty(item.key)) {
					map[item.key] = _.cloneDeep(dataMap);
					}
					map[item.key][key] = item;
				});
			}
		},

		initValues() {
			if (this.data._id) return;
			this.id = null;
			this.fullname = "";
			this.email = "";

			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.lastUpdatedOverview) {
						this.currentData.lastUpdatedOverview = this.lastUpdatedOverview;
					}
					console.log('currentData: ', this.currentData);
					Object.keys(this.currentData).map(k => {
						if (!this.currentData[k] || this.currentData[k] === undefined)
							this.currentData[k] = '';
					});
					this.handlePondUpdate();
					// const dataObj = {
					// 	user: {
					// 		fullname: this.fullname,
					// 		email: this.email,
					// 		isTechnic: true
					// 	}
					// };
					// console.log("[SUBMIT]", dataObj);

					// this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		async handlePondUpdate() {
			try {
				this.$vs.loading();
				await this.$store.dispatch("modulePond/updateDaily", {
					id: this.data._id,
					data: {
						data: this.currentData,
						date: dateNow
					}
				}).then(() => {
					this.$helper.notifySuccess({
						context: this,
						options: {
							text: this.$t("UpdateSuccessful")
						}
					});
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.id ? "UpdateSuccessful" : "CreateSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				if (this.id) {
					await this.$store.dispatch("moduleUser/updateUser", {
						id: this.id,
						data: dataObj
					});
				} else {
					await this.$store.dispatch("moduleUser/addUser", dataObj);
				}
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				console.log("handleCreateOrUpdate User", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	}
};
</script>
